import React, { useState, useEffect } from 'react';
import { 
  Container, 
  Typography, 
  Box, 
  CircularProgress,
  CssBaseline,
  ThemeProvider,
  createTheme
} from '@mui/material';
import Header from './components/Header';
import AssistantIntro from  './components/Intro'
import MetricsInfo from './components/MetricsInfo';
import QueryInput from './components/QueryInput';
import ResponseDisplay from './components/ResponseDisplay';
import SuggestedQuestions from './components/SuggestedQuestions';
import {submitQuery } from './services/api';
import './App.css';

// Create a theme
const theme = createTheme({
  palette: {
    primary: {
      main: '#1976d2',
    },
    secondary: {
      main: '#f50057',
    },
    background: {
      default: '#f5f5f5',
    },
  },
  typography: {
    fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
    h1: {
      fontSize: '2.5rem',
      fontWeight: 500,
    },
    h2: {
      fontSize: '2rem',
      fontWeight: 500,
    },
    h3: {
      fontSize: '1.75rem',
      fontWeight: 500,
    },
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: 8,
        },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          borderRadius: 12,
          boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
        },
      },
    },
  },
});

function App() {
  const [query, setQuery] = useState('');
  const [response, setResponse] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [suggestedQuestions, setSuggestedQuestions] = useState([]);

  // Fetch suggested questions on component mount
  useEffect(() => {
    const loadSuggestedQuestions = async () => {
      // try {
      //   const questions = await fetchSuggestedQuestions();
      //   setSuggestedQuestions(questions);
      // } catch (err) {
      //   console.error('Error loading suggested questions:', err);
      //   setSuggestedQuestions([
      //     "What is the phone fill rate for Surest on latest file?",
      //     "What is the average termination rate for LSEG?",
      //     "What is the average dropout rate for Activision Blizzard?",
      //     "What are the different partners available from surest?",
      //     "What is the address and valid address fill rate for 3Cloud?",
      //     "What is the total active members for Emblemhealth on latest file?",
      //     "Can you say some information about latest file processed on HCSC?",
      //     "How many terminated members for excellus ?"
      // ]);
      // }
      setSuggestedQuestions([
        "What is the phone fill rate for Surest on latest file?",
        "What is the average termination rate for LSEG?",
        "What is the average dropout rate for Activision Blizzard?",
        "What are the different partners available from surest?",
        "What is the address and valid address fill rate for 3Cloud?",
        "What is the total active members for Emblemhealth on latest file?",
        "Can you say some information about latest file processed on United health care?",
        "How many terminated members for excellus ?"
    ]);
    };

    loadSuggestedQuestions();
  }, []);

  const handleQueryChange = (event) => {
    setQuery(event.target.value);
  };

  const handleQuerySubmit = async () => {
    if (!query.trim()) {
      setError('Please enter a question');
      return;
    }

    setLoading(true);
    setError(null);
    setResponse(null);

    try {
      const result = await submitQuery(query);
      setResponse(result);
    } catch (err) {
      console.error('Error submitting query:', err);
      setError(`${err.message || 'An error occurred while generating the response. Please try again.'}`);
    } finally {
      setLoading(false);
    }
  };

  const handleSuggestedQuestionClick = (question) => {
    // Just set the query text without auto-submitting
    setQuery(question);
    // No auto-submission - user must click the Generate Response button
  };

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Box 
        sx={{ 
          minHeight: '100vh',
          backgroundColor: 'background.default',
          pt: 2,
          pb: 6
        }}
      >
        <Header />
        

        <Container maxWidth="md" sx={{ mt: 4 }}>
        <AssistantIntro />

          <SuggestedQuestions 
            questions={suggestedQuestions} 
            onQuestionClick={handleSuggestedQuestionClick} 
          />
          
          <QueryInput 
            query={query} 
            onQueryChange={handleQueryChange} 
            onQuerySubmit={handleQuerySubmit} 
            loading={loading}
          />
          
         
          
          {loading && (
            <Box sx={{ display: 'flex', justifyContent: 'center', mt: 4 }}>
              <CircularProgress />
              <Typography variant="body1" sx={{ ml: 2 }}>
                Thinking... Generating answer...
              </Typography>
            </Box>
          )}
          
          {error && (
            <Box 
              sx={{ 
                mt: 4, 
                p: 2, 
                backgroundColor: '#ffebee', 
                borderRadius: 2,
                color: '#c62828'
              }}
            >
              <Typography variant="body1">{error}</Typography>
            </Box>
          )}
          
          {response && <ResponseDisplay response={response} />}
          <MetricsInfo />

        </Container>
      </Box>
    </ThemeProvider>
  );
}

export default App;
